<script setup lang="ts">
import { computed } from "vue";
interface ModalProps {
  scroll?: boolean;
  width?: number;
  title?: string;
  isVisibleHeader?: boolean;
  canCancel?: boolean | string[];
}

const {
  scroll = false,
  title = "",
  isVisibleHeader = true,
  canCancel = ["escape", "outside"]
} = defineProps<ModalProps>();

const emit = defineEmits(["close", "actionButton"]);

const scrollProp = computed(() => {
  return scroll ? "keep" : "clip";
});
</script>

<template>
  <b-modal :scroll="scrollProp" :can-cancel="canCancel" @close="emit('close')">
    <template #default>
      <div class="modal-card">
        <header v-if="isVisibleHeader" class="modal-card-head">
          <p class="card-header-title modal-font-title">
            {{ title }}
          </p>
          <button type="button" class="delete" @click="emit('close')" />
        </header>
        <section class="modal-card-body">
          <slot name="body" />
        </section>
        <section>
          <slot name="footer" />
        </section>
      </div>
    </template>
  </b-modal>
</template>

<style lang="scss" scoped>
.modal-card {
  border-radius: $spacing-4;
  min-width: 320px;
  max-width: 320px;
  width: 320px;
  height: auto;
  max-height: calc(100vh - 20px);
  @media (min-width: $breakpoint-tablet) {
    max-height: calc(100vh - 40px);
    min-width: 640px;
    max-width: 640px;
    width: 640px;
  }
  @media (min-width: $breakpoint-desktop) {
    max-height: calc(100vh - 160px);
  }
}

.modal-card-head {
  display: flex;
  padding: $size-medium;
  align-items: center;
  gap: $spacing_2;
  align-self: stretch;
  line-height: 112.5%;

  .modal-font-title {
    font-family: $family-body;
    font-style: normal;
    font-size: $spacing_5;
    font-weight: 400;
    line-height: 100%;
    padding: $spacing_0;
  }
}

.modal-card-body {
  display: flex;
  align-items: flex-start;
  padding: $spacing_5 $spacing_6;
  flex-direction: column;
  align-self: stretch;
  width: 100%;
  height: auto;

  > * {
    width: 100%;
  }
}

:deep(.modal-content) {
  display: flex;
  justify-content: center;
  align-items: center;
  overflow-y: auto;
  max-height: 100vh;
}
</style>
